<div *ngFor="let imageBanner of bannerSearch" class="mt-4 mb-4">
  <a [href]="imageBanner?.link" target="{{imageBanner?.target}}">
    <img [src]="imgServer + imageBanner?.img" [alt]="'imagem ' + imageBanner?.description" class="img-fluid">
  </a>
</div>
